module.exports = __webpack_public_path__ + "img/Lefkada.441f2ad9.png";